// One place for the Settings modal's URLs, so the shell and the routes agree
// without importing each other.
export const SETTINGS_PATHS = {
  general: "/settings/general",
  billing: "/settings/billing",
  privacy: "/settings/privacy",
  documents: "/settings/documents",
  support: "/settings/support",
};

// The old Settings page picked its tab with ?activeTab=...; those links now
// open the matching tab of the modal.
export const LEGACY_TAB_PATHS = {
  Billing: SETTINGS_PATHS.billing,
  Security: SETTINGS_PATHS.privacy,
  Documents: SETTINGS_PATHS.documents,
  Support: SETTINGS_PATHS.support,
};
